import styled from 'styled-components';

export const DetailsButton = styled.div`
  width: 35px;
  cursor: pointer;
  margin: 0;
  background: #fff ${({ overwriteGlobalCSS }) => (overwriteGlobalCSS ? '!important' : '')};
  min-height: 43px;
  box-sizing: border-box;
  height: 100%;
  text-decoration: none;
  outline: 0;
  display: ${({ show }) => (!show ? 'none' : 'flex')};
  justify-content: center;
  align-items: center;
  position: relative;
  z-index: 2;
  /* -webkit-appearance: inherit; */

  @media (max-width: 580px) {
    /* width: 100%;
    padding: 0px 3px; */
    min-height: 58px;
  }
`;
